import { createClient, SanityClient } from '@sanity/client'

import sanityConfig from '../../config/sanity'

const sanity: SanityClient = createClient(sanityConfig)

export default sanity
